$(function(){
    $(document).foundation();

    var $errors = $('.error');
    if ($errors.length) {
        var $first_error = $errors.eq(1); // the top message shares the error class
        $(window).scrollTop($first_error.position().top);
        $first_error.focus()
    }
})
